/**
 * The scrollTop that keeps an option inside its popup — pure math, applied by the
 * CityTypeahead highlight effect and tested with plain objects (jsdom has no
 * layout to measure). Its own module so the component file only exports
 * components, which is what keeps Fast Refresh working.
 *
 * scrollIntoView was deliberately rejected for this job: it also scrolls every
 * ancestor, page included, which made the whole screen jump while arrowing
 * through a long list (road-test finding).
 */
export function keepOptionVisible(
  view: { scrollTop: number; clientHeight: number },
  option: { offsetTop: number; offsetHeight: number },
): number {
  if (option.offsetTop < view.scrollTop) {
    return option.offsetTop
  }

  const optionBottom = option.offsetTop + option.offsetHeight
  if (optionBottom > view.scrollTop + view.clientHeight) {
    return optionBottom - view.clientHeight
  }

  return view.scrollTop
}
